import { render, staticRenderFns } from "./maxPriceDialog.vue?vue&type=template&id=8da1cc72&scoped=true"
import script from "./maxPriceDialog.vue?vue&type=script&lang=js"
export * from "./maxPriceDialog.vue?vue&type=script&lang=js"
import style0 from "./maxPriceDialog.vue?vue&type=style&index=0&id=8da1cc72&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da1cc72",
  null
  
)

export default component.exports